import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function useCreatePackaging() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const createPackaging = async (code, label, is_active = true) => {
    setIsSuccess(null);
    try {
      setIsLoading(true);
      await fleetApi.post('/packaging', {
        code,
        label,
        is_active,
      });

      setIsSuccess(true);
      toast.success('Type de packaging créé avec succès.');
    } catch (error) {
      setIsSuccess(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, isSuccess, createPackaging };
}
